<template>
  <article
    id="password-requirements"
    class="auth-ui-card__message-container"
  >
    <div
      class="message is-info"
    >
      <div class="message-body auth-ui-message-body">
        {{ $t('auth.passwordRequirementsTitle') }}
        <ul>
          <li>{{ $t('auth.passwordRequirementsNumbers') }}</li>
          <li>{{ $t('auth.passwordRequirementsLetters') }}</li>
          <li>
            {{ $t('auth.passwordRequirementsSpecial') }}
            <v-tooltip
              :tooltip-text="specialCharacters"
              :custom-class="'auth-ui-password-requirements-tooltip'"
              :triangle-right="true"
            >
              <i class="fa fa-question-circle fa-xs" />
            </v-tooltip>
          </li>
          <li>{{ $t('auth.passwordRequirementsLength') }}</li>
        </ul>
      </div>
    </div>
  </article>
</template>

<script>
import VTooltip from './Tooltip.vue';
/* ============
 * Password Requirements Component
 * ============
 *
 */

export default {
  name: 'PasswordRequirements',

  components: {
    VTooltip,
  },

  data() {
    return {
      specialCharacters: '^ $ * . [ ] { } ( ) ? " ! @ # % & / \\ , > < \' : ; | _ ~ `',
    };
  },
};
</script>
